var map = {
	"./decidim/avatar-multiuser.png": 4158,
	"./decidim/brands/google.svg": 801,
	"./decidim/cc-badge.png": 9664,
	"./decidim/decidim-logo.svg": 3164,
	"./decidim/default-avatar.svg": 7700,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 6048,
	"./decidim/icons.svg": 4143,
	"./decidim/pattern.png": 656,
	"./decidim/placeholder-card-g.svg": 5029,
	"./decidim/placeholder-card-l.svg": 2254,
	"./decidim/placeholder.jpg": 9709,
	"./decidim/remixicon.symbol.svg": 8481,
	"./decidim/vendor/leaflet/layers-2x.png": 5072,
	"./decidim/vendor/leaflet/layers.png": 7359,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 5658,
	"./decidim/vendor/leaflet/marker-icon.png": 7409,
	"./decidim/vendor/leaflet/marker-shadow.png": 7774,
	"./decidim/vendor/social-share-button/douban.svg": 400,
	"./decidim/vendor/social-share-button/email.svg": 877,
	"./decidim/vendor/social-share-button/facebook.svg": 8323,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 8605,
	"./decidim/vendor/social-share-button/hacker_news.svg": 5309,
	"./decidim/vendor/social-share-button/linkedin.svg": 7317,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 3926,
	"./decidim/vendor/social-share-button/pinterest.svg": 8003,
	"./decidim/vendor/social-share-button/reddit.svg": 3111,
	"./decidim/vendor/social-share-button/telegram.svg": 7098,
	"./decidim/vendor/social-share-button/tumblr.svg": 4457,
	"./decidim/vendor/social-share-button/twitter.svg": 3052,
	"./decidim/vendor/social-share-button/vkontakte.svg": 2914,
	"./decidim/vendor/social-share-button/wechat.svg": 9677,
	"./decidim/vendor/social-share-button/whatsapp.svg": 8541,
	"./decidim/vendor/social-share-button/x.svg": 4461,
	"./decidim/vendor/social-share-button/xing.svg": 2195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8179;